import React, {Component} from 'react';

class ReferentenBezirkeSelect extends Component {
    render() {
        return <div className={'form-group'}>
            <label>Regierungsbezirk</label>
                <select className={'form-control custom-select'} id={'Bezirk'} value={this.props.selected} ref={'bezirkeSelect'}
                        onChange={() => this.props.selectBezirk(this.refs.bezirkeSelect.value)}>
                    <option value={"null"}>Alle Regierungsbezirke</option>
                    {
                        this.props.bezirke.map(
                            bezirk => <option key={bezirk.name} value={bezirk.name}>{bezirk.name}</option>
                        )
                    }
                </select>
        </div>
    }
}

export default ReferentenBezirkeSelect




// WEBPACK FOOTER //
// ./src/components/ReferentenBezirkeSelect.js